package uz.mint.frontend.pages.en

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.AllPlansPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.stringsFor
import uz.mint.frontend.seo.IndexablePage

/** Full catalogue in English, exported to `/en/plans/`. */
private val LOCALE = Locale.EN

@InitRoute
fun initEnglishPlansPage(ctx: InitRouteContext) {
    val strings = stringsFor(LOCALE)
    ctx.data.add(PageLayoutData(
            strings.plansMetaTitle,
            LOCALE,
            strings.plansMetaDescription,
            page = IndexablePage.PLANS,
        ))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun EnglishPlansPage() {
    AllPlansPage(LOCALE)
}
